<template>
	<v-card flat height="100vh">
		<v-row class="mt-1 ml-2">
			<v-col cols="12">
				<span style="font-weight: 500;
    font-size: 20px;">Dashboards</span> 
			</v-col>
		</v-row> 

		<!-- Loader State -->
		<div v-if="loading" class="d-flex flex-column align-center justify-center" style="height: 60vh;">
			<v-progress-circular
				indeterminate
				color="primary"
				size="50"
				width="4"
			></v-progress-circular>
			<span class="mt-4 text-grey-darken-1" style="font-size: 14px; font-weight: 500;">
				Loading dashboards...
			</span>
		</div>

		<!-- Dashboard Content -->
		<v-row v-else-if="dashboards && dashboards.length > 0" class="mb-4 ml-2">
			<v-col cols="3" class="d-flex" v-for="(item, index) of dashboards" :key="item.code || index">
				<v-card
				class="mx-auto hover-card d-flex flex-column w-100"
				max-width="400"
				>
				<div class="circle">
					<img class="img-cls" :src="getTheItemData(item,'imageUrl')" />
				</div>
				<v-divider class="mt-15 mb-10" ></v-divider>
						<v-card-title>{{ item.name || '' }}</v-card-title>
					<v-card-text class="flex-grow-1 card-text-summary">
						<div>{{ getTheItemData(item,'summary') }}</div>
					</v-card-text>
					<v-card-actions class="mt-auto card-actions-bottom">
						<v-btn color="primary" text="Open" @click="selectItem(item)"></v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<!-- Empty State -->
		<div v-else class="d-flex justify-center align-center" style="height: 40vh;">
			<span class="text-grey-darken-1" style="font-size: 14px;">No dashboards available</span>
		</div>
	</v-card>
</template>
<script>
import DashboardService from '@/api/service/Dashboard/DashboardService';
import DashboardData from './index'
export default {
	data(){
		return {
			selectedOption:null,
			dashboards:[],
			displayData: [],
			loading: true
		}
	},
	created(){
		this.getDashboardData()
		this.displayData = DashboardData.getTheData()
	},
	methods:{
		async getDashboardData(){
			this.loading = true
			try {
				let res = await DashboardService.getDashboards()
				this.dashboards = res && res.length > 0 ? res : []
			} catch (error) {
				console.error("Error loading dashboards:", error)
				this.dashboards = []
			} finally {
				this.loading = false
			}
		},
		selectItem(item){
			this.selectedOption = item ? item : {}
			this.$router.push(item.route) 
		},
		getClass() {
			return this.defaultClass ? this.defaultClass : 'default-selection'
		},
		getTheItemData(item,key){
			let data = this.displayData.filter(k=>k.code == item.code)
			return data && data.length>0 && data[0][key]?data[0][key]:''
		}
	}

}
</script>
<style scoped>
.img-cls{
    height: 25px; 
    position: absolute;
    bottom: 84px;
    top: 8px;
    left: 13px;   
}
.circle {
    width: 50px;
    height: 50px;
    background-color: #eaedef;
    border-radius: 50%;
    position: absolute;
    bottom: 84px;
    top: 35px;
    left: 45px;
    z-index:1
}
.hover-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.hover-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-text-summary {
  flex-grow: 1;
}

.card-actions-bottom {
  margin-top: auto;
}
</style>
